import { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Alert } from 'antd';

import { RootState } from 'app/appStore';
import { alertsDeleteItem, alertsDeleteItemId, alertsSetItems } from 'widgets/Alerts';

import styles from './Alerts.module.scss';

export const Alerts: FC = () => {
	const dispatch = useDispatch();
	const { alertList, alertIdList } = useSelector((state: RootState) => state.alertsSlice);
	const maxVisibleCount = 3;
	const alerts = useMemo(() => {
		return alertList.slice(maxVisibleCount * -1);
	}, [alertList, maxVisibleCount]);

	const handleItemsChange = (alertId: string) => {
		const findNotificationById = alerts.find(({ id }) => id === alertId);
		if (!findNotificationById) {
			console.error(`The "notification" by id: ${alertId} is not defined on Notifications!`);
			return;
		}
		dispatch(alertsSetItems(alerts.filter(({ id }) => id !== alertId)));
	};

	useEffect(() => {
		alertIdList.forEach((id) => {
			setTimeout(() => {
				dispatch(alertsDeleteItem(id));
			}, 3000);
			dispatch(alertsDeleteItemId(id));
		});
	}, [dispatch, alertIdList]);

	return (
		<div className={styles.list}>
			{alerts?.map((alert) => (
				<Alert
					key={alert.id}
					type={alert.type || 'error'}
					className={styles.item}
					onClose={() => handleItemsChange(alert.id)}
					closable
					message={alert.description}
				/>
			))}
		</div>
	);
};
